export default "<ngb-alert [type]=\"'primary'\" *ngIf=\"!alertClosed\" (close)=\"alertClosed = true\">\n  {{ message }}\n</ngb-alert>\n";